module.exports = __webpack_public_path__ + "img/fb.47e1b034.png";